import React, { useLayoutEffect, useRef } from "react";
import { paintLitCard } from "./ShareCardLighting";

export default function ShareLitCardPreview({ surface, scene, lighting, lights, pixelRatio }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const density = pixelRatio * Math.min(window.devicePixelRatio || 1, 2);
    paintLitCard(ref.current, surface, scene, lighting, lights, density);
  }, [surface, scene, lighting, lights, pixelRatio]);
  return <canvas ref={ref} className="share-editor-lit-card" aria-hidden="true" />;
}
